import { ModelBase } from 'store/model-base';

import { PaymentStoreErrorCode } from 'my-account/constants';

export class AdditionalDevicePaymentResult extends ModelBase {
    public static storeName: string = 'additionalDevicePaymentResult';

    public id: Id;
    public authCode: string;
    public paymentMethod: string;
    public paymentTransactionId: string;
    public amount: number;
    public saveCard: boolean;
    public errorCode: PaymentStoreErrorCode;
    public errorDescription: string;
}
